import { Bug, Lightbulb, HelpCircle, MessageSquare } from "lucide-react";
import { FeedbackType } from "@/hooks/useFeedback";
import { cn } from "@/lib/utils";

interface FeedbackTypeSelectorProps {
  value: FeedbackType;
  onChange: (type: FeedbackType) => void;
}

const types: { value: FeedbackType; label: string; description: string; icon: typeof Bug; color: string }[] = [
  {
    value: 'bug',
    label: 'Bug',
    description: 'Quelque chose ne fonctionne pas',
    icon: Bug,
    color: 'text-red-500 border-red-500/30 bg-red-500/5 hover:bg-red-500/10',
  },
  {
    value: 'suggestion',
    label: 'Suggestion',
    description: "J'ai une idée d'amélioration",
    icon: Lightbulb,
    color: 'text-amber-500 border-amber-500/30 bg-amber-500/5 hover:bg-amber-500/10',
  },
  {
    value: 'question',
    label: 'Question',
    description: "J'ai besoin d'aide",
    icon: HelpCircle,
    color: 'text-blue-500 border-blue-500/30 bg-blue-500/5 hover:bg-blue-500/10',
  },
  {
    value: 'other',
    label: 'Autre',
    description: 'Autre retour',
    icon: MessageSquare,
    color: 'text-gray-500 border-gray-500/30 bg-gray-500/5 hover:bg-gray-500/10',
  },
];

export function FeedbackTypeSelector({ value, onChange }: FeedbackTypeSelectorProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {types.map((type) => {
        const Icon = type.icon;
        const isSelected = value === type.value;
        
        return (
          <button
            key={type.value}
            type="button"
            onClick={() => onChange(type.value)}
            className={cn(
              "flex items-start gap-3 p-3 rounded-lg border-2 transition-all text-left",
              isSelected 
                ? type.color + ' border-current' 
                : 'border-border hover:border-muted-foreground/30'
            )}
          >
            <Icon className={cn("h-5 w-5 mt-0.5 shrink-0", isSelected && type.color.split(' ')[0])} />
            <div className="min-w-0">
              <p className={cn("font-medium text-sm", isSelected && type.color.split(' ')[0])}>
                {type.label}
              </p>
              <p className="text-xs text-muted-foreground truncate">
                {type.description}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
